import React, { useEffect, useState } from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import DatePicker from "react-native-date-picker";

import Button from "components/Button";
import Modal from "components/Modal";
import Icon from "components/Icon";
import Text from "components/Text";

import { getFormatedDate } from "react-native-modern-datepicker";

import { colors, sizes, strings } from "assets/constants";
import { toDualDigit } from "utils";
import { useFlag } from "hooks";

const parseTimeValue = (timeStr: string) => {
  const h = +timeStr.split(":")?.[0];
  const m = +timeStr.split(":")?.[1];
  return { h, m };
};

const NativeTimePicker: React.FC<TimePickerT> = ({
  value,
  placeholder = strings.time,
  hideError,
  error,
  onSelect,
}) => {
  const [valueState, setValueState] = useState(value);

  const [selected, setSelected] = useState(value);

  useEffect(() => {
    value && setValueState(value);
    value && setSelected(value);
  }, [value]);

  const { flg: modal, on: show, off: hide } = useFlag();

  return (
    <>
      <>
        <TouchableOpacity
          onPress={show}
          activeOpacity={sizes.tapOpacity}
          style={styles.container}
        >
          <View style={styles.iconContainer}>
            <Icon name="chevron-down" />
          </View>
          <View style={styles.textContainer}>
            <Text
              size={valueState ? "lg" : "md"}
              weight={valueState ? "bold" : "default"}
              color={value ? colors.textColorDefault : colors.placeholder}
            >
              {valueState || placeholder}
            </Text>
          </View>

          <View style={styles.iconContainer}>
            <Icon name="clock" />
          </View>
        </TouchableOpacity>

        {!hideError && (
          <View style={styles.errorContainer}>
            <Text size={"xs"} color={colors.danger}>
              {error}
            </Text>
          </View>
        )}
      </>

      <Modal
        hideCloseBtn
        visible={modal}
        close={() => {
          hide();
          setSelected(value);
        }}
      >
        <View style={styles.timePickerContainer}>
          <View style={styles.modalContentHeader}>
            <Button
              onPress={() => {
                hide();
                setSelected(value);
              }}
              bgColor={colors.lightButtons}
              circle={40}
              icon={{ name: "x", color: colors.danger, size: 24 }}
            />
            <Text>{strings.set_time}</Text>
            <Button
              onPress={() => {
                setValueState(selected);
                onSelect && selected && onSelect(selected);
                hide();
              }}
              circle={40}
              bgColor={colors.lightButtons}
              icon={{ name: "check", size: 24, color: colors.success }}
            />
          </View>

          <DatePicker
            textColor="black"
            mode="time"
            is24hourSource="locale"
            date={
              !selected
                ? new Date()
                : new Date(
                    2022,
                    1,
                    1,
                    parseTimeValue(selected).h,
                    parseTimeValue(selected).m
                  )
            }
            onDateChange={(date) =>
              setSelected(
                toDualDigit(getFormatedDate(date, "H")) +
                  ":" +
                  toDualDigit(getFormatedDate(date, "m"))
              )
            }
          />
        </View>
      </Modal>
    </>
  );
};

export default NativeTimePicker;

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: 50,
    borderWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    borderColor: colors.border,
    borderRadius: sizes.radius.lg,
    justifyContent: "space-between",
    backgroundColor: colors.itemsBg,
  },

  textContainer: { flex: 1, paddingRight: 2 },

  iconContainer: {
    height: "100%",
    aspectRatio: 1,
    alignItems: "center",
    justifyContent: "center",
  },

  modalContentHeader: {
    width: "100%",
    flexDirection: "row",
    paddingHorizontal: "5%",
    paddingVertical: sizes.space,
    alignItems: "center",
    justifyContent: "space-between",
  },

  timePickerContainer: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.itemsBg,
    borderTopLeftRadius: sizes.radius.md,
    borderTopRightRadius: sizes.radius.md,
  },

  errorContainer: {
    width: "100%",
    alignSelf: "flex-end",
    height: 20,
    marginBottom: 10,
    paddingHorizontal: 5,
  },
});
